var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WholesaleHeader',{attrs:{"img_header":_vm.header_image,"header":"การตั้งราคาสินค้าพิเศษ (Special pricing)","link_back":_vm.link_back}}),_c('Vip_set_special_pricing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }